import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'

import componentStylesDialog from 'assets/theme/components/dialog.js'

const useStylesDialog = makeStyles(componentStylesDialog)

export default function TestPayloadDialog({ open, title, description, defaultPayload, product, productOptions, onProductChange, onSend, onClose, sendLabel = 'Send Test' }) {
    const classes = useStylesDialog()
    const [text, setText] = useState('')
    const [parseError, setParseError] = useState(null)
    const [sending, setSending] = useState(false)

    useEffect(() => {
        if (open) {
            setText(JSON.stringify(defaultPayload || {}, null, 2))
            setParseError(null)
            setSending(false)
        }
    }, [open, defaultPayload])

    async function handleSend() {
        let parsed
        try {
            parsed = JSON.parse(text)
        } catch(e) {
            setParseError(e.message)
            return
        }
        setParseError(null)
        setSending(true)
        try {
            await onSend(parsed)
        } finally {
            setSending(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
            <div className={classes.dialogHeader}>
                <Typography
                    variant='h5'
                    component='h5'
                    className={classes.dialogTitle}
                >
                    {title}
                </Typography>
                <IconButton onClick={onClose}>
                    <Clear />
                </IconButton>
            </div>
            <DialogContent>
                {description && (
                    <Box fontSize='12px' color='#8898aa' marginBottom='0.5rem'>{description}</Box>
                )}
                {productOptions && productOptions.length > 0 && (
                    <Box marginBottom='0.75rem'>
                        <Box fontSize='12px' color='#8898aa' marginBottom='0.25rem'>Product</Box>
                        <select
                            value={product || ''}
                            onChange={(e) => onProductChange && onProductChange(e.target.value)}
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                padding: '0.5rem',
                                border: '1px solid #e9ecef',
                                borderRadius: '4px'
                            }}
                        >
                            {productOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </Box>
                )}
                <textarea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    spellCheck={false}
                    style={{
                        width: '100%',
                        minHeight: '320px',
                        fontFamily: 'monospace',
                        fontSize: '12px',
                        padding: '0.75rem',
                        border: '1px solid #e9ecef',
                        borderRadius: '4px',
                        resize: 'vertical'
                    }}
                />
                {parseError && (
                    <Box fontSize='12px' color='#f5365c' marginTop='0.5rem'>
                        Invalid JSON: {parseError}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='primary' disabled={sending}>Cancel</Button>
                <Button onClick={handleSend} color='primary' variant='contained' disabled={sending}>
                    {sending ? 'Sending...' : sendLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
